import trackCharacterizationAnalytics from 'domains/characterizations/utils/trackCharacterizationAnalytics'
import { CSV_C_MODEL_CHARACTERIZATIONS_RECORD } from 'lib/records/modules/csvCModelCharacterizations'
import { updateRecord } from 'lib/records/workflows/updateRecord'
import { ONER_V1P1_CSV_ROSTERING_IMPORT_BULK } from 'domains/formats/constants/formats'

export const createCSVCModelCharacterization = async (
  modelId: number | string,
) => {
  trackCharacterizationAnalytics('submitted_model_characterization', {
    format: ONER_V1P1_CSV_ROSTERING_IMPORT_BULK,
  })
  const { data, success } = await updateRecord(
    CSV_C_MODEL_CHARACTERIZATIONS_RECORD,
    modelId,
  )
  return success ? data : success
}
